import React from 'react';
import { useInAppMessages } from '../hooks/inAppMessages/useInAppMessages';
import { InAppMessageCards } from './InAppMessageCards';
import { designShows } from '../design/previewPath';
import { PavilionInAppMessagesDoor } from '../design/pavilion/withPavilion';

/*
 * THE IN-APP MESSAGE OVERLAY: the platform's messages to a signed-in person, as cards above the chat's bar. What it does
 * is the hook's (src/hooks/inAppMessages/useInAppMessages.ts: the listener, the delivery marks, the chat hand-off, the
 * sweep, every button and the inline form; D-92's light-only surfaces: the overlay, part 1); this file asks it once and
 * draws the view it returns: today's cards (./InAppMessageCards.tsx), or, where the `in-app-messages` surface shows, the
 * new design's (src/design/pavilion/appmessages/, through withPavilion.tsx's door, fetched from the first message on),
 * with today's cards as the door's fallback (part 2).
 */
export const InAppMessageOverlay: React.FC = () => {
  const view = useInAppMessages();
  if (!view.shown) return null;
  if (designShows('in-app-messages')) return <PavilionInAppMessagesDoor view={view} fallback={<InAppMessageCards view={view} />} />;
  return <InAppMessageCards view={view} />;
};

export default InAppMessageOverlay;
